import React from 'react';
import styled from '@emotion/styled';
import DefaultLayout from "../../containers/layouts";

function Help() {
  return (
      <DefaultLayout>
          <Header>
              <h4>In progress {new Date().getTime()}</h4>
          </Header>
      </DefaultLayout>
  );
}

export default Help;

const Header = styled.header`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
